import { Versions, initialState, viewSelector,UPLOAD_VERSION_SHARES_CONTEXT} from './versions.state';
import { VersionsActions, VersionsActionType } from './versions.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';

import * as VS from '@core/models/version-share.model';
import { VersionShareFeedbackMessage, VersionShareFeedbackMessageType } from '@core/models/version-share-message.model';

export function versionsReducer(state = initialState, action: VersionsActions): Versions {
    switch (action.type) {
		// EVENTS STATUS
        case VersionsActionType.Clear:
            return {...state, view: initialState.view, errors: initialState.errors};
    
        case VersionsActionType.ClearFiles:
            return {...state, view: {...state.view, files: initialState.view.files}};

        /**
         * Load views
         */
        case VersionsActionType.LoadVersionSuccess:
            return {...state, view: {...state.view, version: action.version, id: action.version.id }, errors: {...state.errors, load_version: new HttpErrorResponse({ status: 200, statusText: 'OK' })  }};

        case VersionsActionType.LoadVersionError:
            return {...state, view: {...state.view, version: null}, errors: {...state.errors, load_version: action.error }};
        case VersionsActionType.LoadPartialVersionSuccess:
            return {...state, view: {...state.view, 
                                        id: action.version.id, 
                                        version : action.version }, errors: {...state.errors, load_version: new HttpErrorResponse({ status: 206, statusText: 'Partial Content' })  }};                      
        case VersionsActionType.LoadVersionFilesSuccess:
            return {...state, view: {...state.view, files: action.files}, errors: {...state.errors, load_version_files: null }};
        
        case VersionsActionType.LoadVersionFilesError:
            return {...state, view: {...state.view, files: []}, errors: {...state.errors, load_version_files: action.error }};
        
        case VersionsActionType.LoadRelatedVersionsSuccess:
            return {...state, view: {...state.view, relateds: action.versions }, errors: {...state.errors, load_version: null }};

        case VersionsActionType.LoadRelatedVersionsError:
            return {...state, view: {...state.view, relateds: []}, errors: {...state.errors, load_version: action.error }};

        case VersionsActionType.LoadVersionProjectSuccess:
            return {...state, view: {...state.view, project: action.project}, errors: {...state.errors, load_version_project: null }};
        
        case VersionsActionType.LoadVersionProjectError:
            return {...state, view: {...state.view, project: null}, errors: {...state.errors, load_version_project: action.error }};

        case VersionsActionType.LoadVersionCommentsSuccess:
            return {...state, view: {...state.view, comments: action.versionComments}, errors: {...state.errors, load_version_comments: null }};

        case VersionsActionType.LoadVersionCommentsError:
            return {...state, errors: {...state.errors, load_version_comments: action.error }};
    
        case VersionsActionType.LoadVersionFeedbacksSuccess:
            return {...state, view: {...state.view, feedbacks: action.feedbacks}, errors: {...state.errors, load_version_feedbacks: null }};

        case VersionsActionType.LoadVersionFeedbacksError:
            return {...state, errors: {...state.errors, load_version_feedbacks: action.error }};

        // case VersionsActionType.LoadVersionFeedbackFileNotesSuccess:
        //     return {...state, view: {...state.view, 
        //                 feedback_notes: // need to filter to add new ones from different files
        //                 [...state.view.feedback_notes.filter((fn: Note) => action.file.id != fn.file.id), ...action.notes]
        //             },
        //             errors: {...state.errors, load_feedback_notes: null }
        //         };
        
        // case VersionsActionType.LoadVersionFeedbackFileNotesError:
        //     return {...state, view: {...state.view, feedback_notes: initialState.view.feedback_notes}, errors: {...state.errors, load_feedback_notes: action.error }};
                
        case VersionsActionType.LoadVersionFeedbackNotesCounterSuccess:
            return  {...state, 
                        view: {...state.view, 
                            feedback_notes_counter: action.counter
                        },
                        errors: {...state.errors, load_feedback_notes_counter: null }
                    };


        case VersionsActionType.LoadVersionFeedbackNotesCounterError: 
            return {...state, view: {...state.view, feedback_notes_counter: initialState.view.feedback_notes_counter}, errors: {...state.errors, load_feedback_notes_counter: action.error }};
        case VersionsActionType.LoadShareFeedbackSuccess:
            // need to filter the share feedback to get the one of the current version
            let shVerFeeds = action.shareFeedbacks.filter((f: VS.ShareVersionFeedback) => f.version.id == action.version.id )
            let myFeedback = shVerFeeds.length > 0 ? shVerFeeds[0] : null;
            return {...state, 
                view: {...state.view, 
                    share_feedback:  myFeedback
                    }, 
                errors: {...state.errors, load_share_feedback: null }
            };
        
        case VersionsActionType.LoadShareFeedbackError:
            return {...state, view: {...state.view, share_feedback: initialState.view.share_feedback }, errors: {...state.errors, load_share_feedback: action.error }};
    
        /**
         * Setters
         */
        case VersionsActionType.SetVersionStatus:
            return {...state, view: {...state.view, version: {...state.view.version, status: action.status}}, errors: {...state.errors, set_version_status: null }};

        case VersionsActionType.SetVersionStatusSuccess:
            return {...state, errors: {...state.errors, set_version_status: null }};
    
        case VersionsActionType.SetVersionStatusError:
            return {...state, errors: {...state.errors, set_version_status: action.error }};

        case VersionsActionType.SetVersionLabels:
            return {...state, view: {...state.view, version: {...state.view.version, labels: action.labels}}, errors: {...state.errors, set_version_status: null }}
        
        case VersionsActionType.SetVersionLabelsSuccess:
            return {...state, errors: {...state.errors, set_version_labels: null}}
        
        case VersionsActionType.SetVersionLabelsError:
            return {...state, errors: {...state.errors, set_version_labels: action.error}}
        /**
         * Load editors
         */
        case VersionsActionType.LoadEditorAccessSuccess:
            return {...state, editor: {...state.editor, access: action.access}, errors: {...state.errors, load_editor_access: null}};
        
        case VersionsActionType.LoadEditorAccessError:
            return {...state, errors: {...state.errors, load_editor_access: action.error}};

        // actions for feedback archive
        case VersionsActionType.ArchiveVersionFeedback:
            // return state;
            return {...state, 
                actions_status: {
                    ...state.actions_status, archive_feedback:{...state.actions_status.archive_feedback, loading: true, success: false, error: null }
                }
            };

        case VersionsActionType.ArchiveVersionFeedbackSuccess:

            return {...state, 
                actions_status: {
                    ...state.actions_status, archive_feedback:{...state.actions_status.archive_feedback, loading: false, success: true }
                },
                view: {
                    ...state.view, feedbacks: state.view.feedbacks.filter((f:VS.VersionFeedback) => f.user.id != action.feedback.user.id)}
            };
        
        case VersionsActionType.ArchiveVersionFeedbackError:
            return {...state, 
                actions_status: {
                    ...state.actions_status, archive_feedback:{...state.actions_status.archive_feedback, loading: false, success: false, error: action.error }
                }
            };

        // dec-2023 actions for load VersionShares
        case VersionsActionType.LoadVersionShares:
            return {...state, 
                view: {...state.view, 
                    version_share_messages: initialState.view.version_share_messages
                    }
                };
        case VersionsActionType.LoadVersionSharesSuccess:

            const shareMessages:  VersionShareFeedbackMessage[] =  action.shares
                .filter((vsi: VS.VersionShare) =>
                    (vsi.type === VS.VersionShareType.UPLOAD_VERSION_TYPE && vsi.status.status_code === VS.UploadVersionStatusCodeEnum.CLOSED_CODE ) || 
                    (vsi.type === VS.VersionShareType.APPROVAL_TYPE && vsi.status.status_code != VS.ApprovalStatusCodeEnum.PENDING_CODE )
                )
                .map((vs: VS.VersionShare) => {
                    let user_shares =  action.shares.filter((vsu: VS.VersionShare ) => vsu.entry.user.id === vs.entry.user.id);
                    switch (vs.type) {
                        case VS.VersionShareType.UPLOAD_VERSION_TYPE:
                            const msguv: VersionShareFeedbackMessage = { 
                                uuid: uuidv4(),
                                type: VersionShareFeedbackMessageType.UPLOADED_MESSAGE_TYPE,  
                                message:  "Uploaded new version "+vs.options?.version, 
                                version_share: vs, 
                                // user: vs.entry.user, // not for now
                                user_version_shares:  user_shares,
                                date: vs.status.date,
                                version: action.version
                            } ;
                            return msguv;
                            break;
                    
                        case VS.VersionShareType.APPROVAL_TYPE:
                            const msgap: VersionShareFeedbackMessage = { 
                                uuid: uuidv4(),
                                type: VersionShareFeedbackMessageType.APPROVAL_MESSAGE_TYPE,  
                                message:  vs.options?.message,
                                version_share: vs, 
                                // user: vs.entry.user, // not for now
                                user_version_shares: user_shares,  
                                date: vs.status.date,
                                version: action.version
                            } ;
                            return msgap;
                            
                            break;
                    }
                });

            return {...state, 
                view: {...state.view, 
                    version_shares: action.shares,
                    version_share_messages: [...state.view.version_share_messages, ...shareMessages]
                }, 
                errors: {...state.errors, load_version_shares: null }};

        case VersionsActionType.LoadVersionSharesError:
            return {...state, errors: {...state.errors, load_version_shares: action.error }};
        
        // jan-2024 actions for load UploadVersionShares for curretn user and all users.
        case VersionsActionType.LoadUploadVersionSharesSuccess:
            // Check the context property and update the state accordingly (repeated for the user? yes.)
            switch (action.context) {
                case UPLOAD_VERSION_SHARES_CONTEXT.current_user:
                    
                    return {...state, view: {...state.view, 
                            upload_version_shares: action.versionShares.filter((uvs: VS.UploadVersionShare) => uvs.origin.version.id == state.view.version.id)
                        }, 
                        errors: {...state.errors, load_upload_version_shares: null }
                    };
                case UPLOAD_VERSION_SHARES_CONTEXT.all_users:
                    return { ...state,view: {...state.view, 
                            all_upload_version_shares: state.view.all_upload_version_shares != null ? [...state.view.all_upload_version_shares, ...action.versionShares] : action.versionShares
                        },
                        errors: {...state.errors, load_upload_version_shares: null }
                        };
                default:
                    // Handle other contexts maybe in the future.
                    return state;
            }
            

        case VersionsActionType.LoadUploadVersionSharesError:
            return {...state, errors: {...state.errors, load_upload_version_shares: action.error }};

        case VersionsActionType.LoadUploadedVersionSuccess:
            return {...state, 
                view: {...state.view, 
                    uploaded_version_uploads: [...state.view.uploaded_version_uploads, action.version]
                }, 
                errors: {...state.errors, load_version_shares: null }};
        
        // action for archive version share (a feedback)
        case VersionsActionType.ArchiveVersionShare:
            // return state;
            return {...state, 
                actions_status: {
                    ...state.actions_status, archive_version_share:{...state.actions_status.archive_version_share, loading: true, success: false, error: null, dispatcher : action.dispatcherKey }
                }
            };
        case VersionsActionType.ArchiveVersionShareSuccess:
            return {...state, 
                actions_status: {
                    ...state.actions_status, archive_version_share:{...state.actions_status.archive_version_share, loading: false, success: true }
                },
                view: {
                    ...state.view, version_shares: state.view.version_shares.filter((f:VS.VersionShare) => f.entry.token != action.share.entry.token)}
            };
        
        case VersionsActionType.ArchiveVersionShareError:
            return {...state, 
                actions_status: {
                    ...state.actions_status, archive_version_share:{...state.actions_status.archive_version_share, loading: false, success: false, error: action.error }
                }
            };
        
        case VersionsActionType.ResetArchiveActionStatus:
            return {...state, 
                actions_status: {
                    ...state.actions_status, archive_version_share: initialState.actions_status.archive_version_share
                }
            };
        // may-2023 action for reset version share (not upload version by now)
        case VersionsActionType.ResetVersionShare:
            // return state;
            return {...state, 
                actions_status: {
                    ...state.actions_status, reset_version_share:{...state.actions_status.reset_version_share, loading: true, success: false, error: null, dispatcher : action.dispatcherKey }
                },
                // DONT set status to pending in the proper share before reload. (15-may-2024)
                
            };
        case VersionsActionType.ResetVersionShareSuccess:
            return {...state, 
                actions_status: {
                    ...state.actions_status, reset_version_share:{...state.actions_status.reset_version_share, loading: false, success: true }
                },
                view: {
                    ...state.view, version_shares: state.view.version_shares.map((share: VS.VersionShare) => {
                        if (share.entry.token === action.share.entry.token && share.type === action.share.type) {
                            // If the token and type match, update the status_code accordingly
                            const uStatus: VS.VersionShareStatus = { ...share.status };
                            uStatus.status_code = action.share.type === VS.VersionShareType.APPROVAL_TYPE ? 
                                            VS.ApprovalStatusCodeEnum.PENDING_CODE : VS.FeedbackStatusCodeEnum.OPENED_CODE;
                                            uStatus.status_text = action.share.type === VS.VersionShareType.APPROVAL_TYPE ? 
                            VS.ApprovalStatusTextEnum.PENDING_TEXT : VS.FeedbackStatusTextEnum.OPENED_TEXT;
                            const newStatusDate = new Date();
                            uStatus.date = newStatusDate.toISOString();
                            // Return the updated Versionshare object
                            return {
                                ...share,
                                status: uStatus
                            };
                        } else {
                            // If the token and type don't match, return the share object as is
                            return share;
                        }
                    })
                }
            };
        
        case VersionsActionType.ResetVersionShareError:
            return {...state, 
                actions_status: {
                    ...state.actions_status, reset_version_share:{...state.actions_status.reset_version_share, loading: false, success: false, error: action.error }
                }
            };
        case VersionsActionType.ResetResetActionStatus:
            return {...state, 
                actions_status: {
                    ...state.actions_status, reset_version_share: initialState.actions_status.reset_version_share
                }
            };
        case VersionsActionType.ResetUploadVersionFilesActionStatus:
            return {...state, 
                actions_status: {
                    ...state.actions_status, send_version_files: initialState.actions_status.send_version_files
                }
            };
        // upload artwork for share feature.
        case VersionsActionType.SendUploadVersionFiles:
            return {...state, 
                actions_status: {
                    ...state.actions_status, send_version_files:{...state.actions_status.send_version_files, loading: true, success: false, error: null }
                }
            };

        case VersionsActionType.SendUploadVersionFilesSuccess:
            return {...state, 
                actions_status: {
                    ...state.actions_status, send_version_files:{...state.actions_status.send_version_files, loading: false, success: true }
                },
            };
        
        case VersionsActionType.SendUploadVersionFilesError:
            return {...state, 
                actions_status: {
                    ...state.actions_status, send_version_files:{...state.actions_status.send_version_files, loading: false, success: false, error: action.error }
                }
            };
        // self feedabck action management

        case VersionsActionType.ResetSelfShareFeedbackRequestActionStatus:
            return {...state, 
                actions_status: {
                    ...state.actions_status, send_self_feedback_request: initialState.actions_status.send_self_feedback_request
                }
            };
        // upload artwork for share feature.
        case VersionsActionType.SendSelfShareFeedbackRequest:
            return {...state, 
                actions_status: {
                    ...state.actions_status, send_self_feedback_request:{...state.actions_status.send_self_feedback_request, loading: true, success: false, error: null }
                }
            };

        case VersionsActionType.SendSelfShareFeedbackRequestSuccess:

            return {...state, 
                actions_status: {
                    ...state.actions_status, send_self_feedback_request:{...state.actions_status.send_self_feedback_request, loading: false, success: true }
                },
            };
        
        case VersionsActionType.SendSelfShareFeedbackRequestError:
            return {...state, 
                actions_status: {
                    ...state.actions_status, send_self_feedback_request:{...state.actions_status.send_self_feedback_request, loading: false, success: false, error: action.error }
                }
            };
	    default:
	        return state;
    }
}
